/**
 * @fileoverview The text of a delivery-status badge where the status alone
 * does not say it (MOR-2319).
 *
 * Under `MAIL_PROVIDER=ses` a `complained` message is one the recipient's
 * mail provider reported back as a complaint, and SES's feedback types are
 * not all spam: `abuse` is (unsolicited mail or other abuse), but
 * `not-spam`, `auth-failure`, `fraud`, `virus` and `other` are not. The
 * events handler records the type in `deliveryDetail` as a slug
 * (`complaint.abuse`), so the label says "spam" only for that one and is
 * neutral for the rest, and for a complaint with no recorded type.
 */

/** The `deliveryDetail` slug of an SES complaint whose feedback type is `abuse`. */
const SPAM_COMPLAINT_DETAIL = "complaint.abuse";

/** "Marked as spam" for an `abuse` complaint, else a neutral "Complaint". */
export function complaintLabel(deliveryDetail: string | undefined): string {
  return deliveryDetail === SPAM_COMPLAINT_DETAIL
    ? "Marked as spam"
    : "Complaint";
}

/**
 * The badge text for a message: `fallback` (the status's own label) for
 * every status but `complained`, which reads its detail.
 */
export function deliveryLabel(
  message: { deliveryStatus?: string; deliveryDetail?: string },
  fallback: string,
): string {
  return message.deliveryStatus === "complained"
    ? complaintLabel(message.deliveryDetail)
    : fallback;
}
